
import * as action from '../actions/license';
import {
  generateUsageId,
  getUsageIndexById,
  isLicenseValid,
  setComponentForUsage,
} from '../helpers/license';

import * as update from 'immutability-helper';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

const defaultList = [];

const initialState: ITermsState = {
  currentMediumEdit: null,
  editingUsageIndex: null,
  isValid: false,
  usages: defaultList,
};

type Handler<K = undefined> = ReducerHandler<ITermsState, K>;

const setEditingUsageIndexHandler: Handler<ILicenseEditUsageActionPayload> =
  (state, { index }) => ({
    ...state, editingUsageIndex: index,
  });

const setUsagesHandler: Handler<ILicenseSetUsagesActionPayload> =
  (state, { scope, usages }) => {
    const currentMediumEdit = !!usages.length ? usages[0].medium.id as LicenseMediaTypeIdentifier : null;
    return {
      ...state,
      currentMediumEdit,
      isValid: isLicenseValid(usages),
      scope: scope || state.scope,
      usages,
    };
  };

const addMediumHandler: Handler<ILicenseAddMediumActionPayload> =
  (state, usage) => {
    return {
      ...state,
      isValid: false,
      usages: [
        ...state.usages, {
          id: generateUsageId(usage, state.usages.length), // `${medium.id}${state.usages.length}`,
          medium: usage.medium,
          contextual_param_type: usage.contextualParamType,
        },
      ],
    };
  };

const removeMediumHandler: Handler<ILicenseRemoveUsageActionPayload> =
  (state, { id }) => {
    const usages: ILicenseUsage[] = update(state.usages, {
      $splice: [[getUsageIndexById(id)(state), 1]],
    });

    return {
      ...state,
      isValid: isLicenseValid(usages),
      usages,
    };
  };

const setComponentForUsageHandler: Handler<ISetComponentForUsageActionPayload> =
  (state, { component, index, value }) => {
    if (index < state.usages.length) {
      const updatedUsage = setComponentForUsage(index, component, value)(state);
      const usages: ILicenseUsage[] = update(state.usages, {
        $splice: [[index, 1, updatedUsage]],
      });

      return {
        ...state,
        isValid: isLicenseValid(usages),
        usages,
      };
    }

    return state;
  };

const clearLicenseHandler: Handler = () => initialState;

export default reducerWithInitialState(initialState)
  .case(action.setUsages, setUsagesHandler)
  .case(action.addMedium, addMediumHandler)
  .case(action.removeMedium, removeMediumHandler)
  .case(action.setEditingUsageIndex, setEditingUsageIndexHandler)
  .case(action.setComponentForUsage, setComponentForUsageHandler)
  .case(action.clearLicense, clearLicenseHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/license.ts